var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrello(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3348 0.105192H2.13616C1.08675 0.105192 0.235629 0.955709 0.2342 2.0058V14.1943C0.23217 14.7004 0.43165 15.1865 0.788556 15.545C1.14546 15.9036 1.6304 16.1052 2.13616 16.1052H14.3348C14.8401 16.1045 15.3244 15.9026 15.6807 15.5441C16.0371 15.1856 16.2362 14.7 16.2342 14.1943V2.0058C16.2327 0.95671 15.3832 0.106605 14.3348 0.105192ZM7.13454 11.6294C7.13386 11.7986 7.06589 11.9605 6.94563 12.0794C6.82538 12.1982 6.66276 12.2643 6.49372 12.263H3.82792C3.47926 12.2615 3.19736 11.9783 3.19736 11.6294V3.69096C3.19736 3.34206 3.47926 3.05883 3.82792 3.05742H6.49372C6.84281 3.05883 7.12545 3.34165 7.12685 3.69096L7.13454 11.6294ZM13.2864 7.98464C13.2864 8.15401 13.2186 8.31633 13.0982 8.43536C12.9778 8.5544 12.8148 8.62023 12.6456 8.61822H9.97977C9.63069 8.61677 9.34805 8.33395 9.34664 7.98464V3.69096C9.34805 3.34165 9.63069 3.05883 9.97977 3.05742H12.6456C12.9942 3.05883 13.2761 3.34206 13.2761 3.69096L13.2864 7.98464Z",
    fill: "url(#paint0_linear_1_4)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_4",
    x1: 2498.63,
    y1: 1024.11,
    x2: 2498.63,
    y2: 0.105192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrello);
export default __webpack_public_path__ + "static/media/Trello.268d21318882a0d3102c94007a76ca85.svg";
export { ForwardRef as ReactComponent };